"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardItemHeadlineContainer = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var SMALLEST_WIDGET_HEIGHT = 120;
var SMALL_WIDGET_HEIGHT = 140;
var SMALL_HEIGHT = 38;
var SMALL_LINE_HEIGHT = 36;
exports.DashboardItemHeadlineContainer = function (_a) {
    var children = _a.children, clientHeight = _a.clientHeight;
    var isSmallCustomHeight = function () { return clientHeight < SMALLEST_WIDGET_HEIGHT; };
    var customMargin = clientHeight <= SMALL_WIDGET_HEIGHT ? { marginTop: 0 } : undefined;
    var customStyle = isSmallCustomHeight()
        ? { height: SMALL_HEIGHT + "px", lineHeight: SMALL_LINE_HEIGHT + "px" }
        : undefined;
    return (react_1.default.createElement("div", { className: "item-headline-outer", style: tslib_1.__assign(tslib_1.__assign({}, customStyle), customMargin) },
        react_1.default.createElement("div", { className: "item-headline", style: isSmallCustomHeight() ? { fontSize: "15px" } : undefined }, children)));
};
//# sourceMappingURL=DashboardItemHeadlineContainer.js.map